'use strict';
const angular = require('angular');

export class TextMessageEditComponent {
  MAX_CHARS = 160;

  /*@ngInject*/
  constructor() {
    this.charsLeft = this.MAX_CHARS;
    this.message = '';
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.message = angular.copy(this.config.data);
      this.updateChars();
    }
  };

  updateChars() {
    if (this.message.length > this.MAX_CHARS)
      this.message = this.message.substring(0, this.MAX_CHARS);

    this.charsLeft = this.MAX_CHARS - this.message.length;
  }

  ok() {
    this.close({$value: this.message});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.textMessageEdit', [])
  .component('textMessageEdit', {
    template: require('./text-message-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: TextMessageEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/text-message-edit/text-message-edit.component.js